/* eslint quotes: "off" */
import $ from "jquery";

$.extend(jQuery.easing, {

  easeInOutQuad: function (t) { return t<.5 ? 2*t*t : -1+(4-2*t)*t },

  easeOutBounce: function (x, t, b, c, d) {
    if ((t/=d) < (1/2.75)) {
      return c*(7.5625*t*t) + b;
    } else if (t < (2/2.75)) {
      return c*(7.5625*(t-=(1.5/2.75))*t + .75) + b;
    } else if (t < (2.5/2.75)) {
      return c*(7.5625*(t-=(2.25/2.75))*t + .9375) + b;
    } else {
      return c*(7.5625*(t-=(2.625/2.75))*t + .984375) + b;
    }
  }
});

export const debounce = (cb, duration) => {
  let timer;
  let resolves = [];

  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      let result = cb(...args);
      resolves.forEach(r => r(result));
      resolves = [];
    }, duration);

    return new Promise(r => resolves.push(r));
  };
};

export const spinTheWheel = (clicks, degree, num) => {
  //add 1 every click
  clicks ++;

  /*multiply the degree by number of clicks
   generate random number between 1 - 360,
   then add to the new degree*/
  const newDegree = degree * clicks;
  const extraDegree = Math.floor(((6 - (num + 1))*(1/6) + (1/6)) * (360 - 1 + 1)) + 1;
  const totalDegree = newDegree + extraDegree;

  /*let's make the spin btn to tilt every
   time the edge of the section hits
   the indicator*/
  $('#wheel .sec').each(function(){
    let t = $(this);
    let c = 0;
    let n = 700;
    const interval = setInterval(function () {
      c++;
      if (c === n) {
        clearInterval(interval);
      }
      let aoY = t.offset().top;
      $("#txt").html(aoY);

      /*23.7 is the minumum offset number that
       each section can get, in a 30 angle degree.
       So, if the offset reaches 23.7, then we know
       that it has a 30 degree angle and therefore,
       exactly aligned with the spin btn*/
      if (aoY < 23.89){
        $('#spin').addClass('spin');
        setTimeout(function () {
          $('#spin').removeClass('spin');
        }, 100);
      }
    }, 10);
    $('#inner-wheel').css({
      'transform' : 'rotate(' + totalDegree + 'deg)'
    });
  });
  return clicks;
};

export const stopSpinningTheWheel = () => {
  const wheel = $('#inner-wheel');
  const e = wheel.css('transform'); // get the current state
  wheel.css('transform', e);
};

export const draw = (id, percen) => {
  drawElement(percen);
  function drawElement(percentage) {
    var circle = $('#green-halo_' + id);
    var perc = $('#perc_' + id);
    console.log(circle);
    console.log(perc);

    var interval = 15;
    var angle = 0;
    var angle_increment = 6;

   const interval1 = window.setInterval(function () {
      circle.attr("stroke-dasharray", angle + ", 360");
      perc.html(percentage + '%');
     if (angle >= (percentage*360/100)) {
        window.clearInterval(interval1);
        fillCirc(angle);
      }

      angle += angle_increment;
    }.bind(this), interval);
  }
  function fillCirc(circ_percentage) {
    var circle = $('#green-halo_' + id);
    console.log(circle);
    circle.attr('stroke-dasharray', '0, 360');
    $({countValue:0}).animate(
      {countValue: 270},
      {
        duration: 1000,
        easing:'easeOutBounce',
        step: function (value) {
          circle.attr("stroke-dasharray", circ_percentage + ", 360");
        }
      }
    );
  }
};

export const loading = () => {
  setTimeout(() => {
    document.querySelectorAll(".bar").forEach((current) => {
      let startWidth = 0;
      const endWidth = current.dataset.size;
      if (endWidth) {
        const interval = setInterval(() => {
          if (startWidth >= endWidth) {
            clearInterval(interval);
          } else {
            startWidth++;
            current.style.width = `${endWidth}%`;
            current.firstElementChild.innerText = `${startWidth}%`;
          }
        }, 20);
      }
    });
  }, 1000);
};

export const handleLanguageDropdown = () => {
  $('.main-nav .dropdown').click(function () {
    $(this).stop().toggleClass("open");
  });
  $(document).on('click', function (event) {
    var container = $('.main-nav .dropdown');
    if (!container.is(event.target) && container.has(event.target).length === 0) {
      container.removeClass("");
    }
  });
};

export const handleBurgerButton = () => {
  $('.nav__toggle').click(function (e) {
    e.preventDefault();
    var showOverlay = false;
    if ($(this).hasClass('avatar')) {
      $('#nav_dropdown').fadeOut();
      if ($('.nav__toggle').hasClass('active')) {
        showOverlay = true;
      }
    }
    if ($(this).hasClass('nav__toggle')) {
      $('#nav_dropdown_user').fadeOut();
      if ($('.avatar').hasClass('active')) {
        showOverlay = true;
      }
    }
    var menu = $(this).data('menu');
    $(this).stop().toggleClass('active');
    if (!showOverlay) {
      $('.black-overlay').stop().fadeToggle(200);
    }
    $('#' + menu).stop().fadeToggle(200);
  });
  $('.black-overlay').click(function () {
    $('.nav__toggle').removeClass('active');
    $('.black-overlay').stop().fadeToggle(200);
    $('#nav_dropdown_user, #nav_dropdown, #get_started_menu').stop().fadeOut(200);
  });
  // open modal
  $('.modal,.modal-overlay').fadeIn(200);
  // show/hide modal
  $('.modal-close, .modal-overlay').click(function () {
    $('.modal, .modal-overlay').fadeOut();
  });
};

export const closeTab = () => {
  $('.nav__toggle').removeClass('active');
  $('.black-overlay').stop().fadeToggle(200);
  $('#nav_dropdown_user, #nav_dropdown, #get_started_menu').stop().fadeOut(200);
  $('.main-nav .dropdown').removeClass('open');
};

export const squareLoaderAnimation = () => {
  // square animation
  const height = $(document).height();
  const width = $(document).width();
  const offset = 2 * width + 2 * height;
  $('.square-loader svg rect').css({'stroke-dasharray':offset, 'stroke-dashoffset':offset});
  // start the timer
  $('.square-loader').addClass('start');
};

export const randomSearchAnimation = (vueInstance) => {
  let counter = 0;
  vueInstance.timer = setInterval(() => {
    counter++;
    const random = Math.floor(Math.random()*(16-1+1)+1);
    $('.avatar-item').removeClass('active');
    $('.avatar-item:nth-child('+random+')').addClass('active');
  }, 400);
};

export const opponentFoundVSText = () => {
  const el = $('.opponent-found__vs');
  const w = el.width();
  const h = el.height();
  const $text = $('.opponent-found__vs span');
  $text.css('font-size',w/1.8);
};

export const pieChartAnimation = (selectorElement, percent) => {
  if(!$(selectorElement).length) {
    return;
  }
  const el = selectorElement;
  const donut = true;
  percent = Math.round(percent);
  if (percent > 100) {
    percent = 100;
  } else if (percent < 0) {
    percent = 0;
  }
  const deg = Math.round(360 * (percent / 100));

  if (percent > 50) {
    $(el + ' .pie').css('clip', 'rect(auto, auto, auto, auto)');
    $(el + ' .right-side').css('transform', 'rotate(180deg)');
  } else {
    $(el + ' .pie').css('clip', 'rect(0, 1em, 1em, 0.5em)');
    $(el + ' .right-side').css('transform', 'rotate(0deg)');
  }
  if (donut) {
    $(el + ' .right-side').css('border-width', '16px');
    $(el + ' .left-side').css('border-width', '16px');
    $(el + ' .shadow').css('border-width', '16px');
  } else {
    $(el + ' .right-side').css('border-width', '1.0em');
    $(el + ' .left-side').css('border-width', '1.0em');
    $(el + ' .shadow').css('border-width', '1.0em');
  }
  $(el + ' .left-side').css('transform', 'rotate(' + deg + 'deg)');
};

export const updateProgressBarGamesWon = (percent) => {
  $('#gamesWon').each(function(i, obj) {
    $(obj).width(percent+"%");
  });
};

export const updateProgressBarAnswersPercent = (percent) => {
  $('#correctAnswers').each(function(i, obj) {
    $(obj).width(percent+"%");
  });
};



// WEBPACK FOOTER //
// ./src/common/jQuery.js